import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=d98c7b14&"
import script from "./EditPage.vue?vue&type=script&lang=js&"
export * from "./EditPage.vue?vue&type=script&lang=js&"
import style0 from "./EditPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports